import config from 'Config';
const agreementKey = config.sessionStorage.personalDataAgreement;
const requiredAgreementKey = config.sessionStorage.requiredAgreement;
const certificateTokenKey = config.sessionStorage.certificateToken;
const certificateReservationKey = config.sessionStorage.certificateReservation;
const savedReservationCodeKey = config.sessionStorage.savedReservationCode;

const setReservationCode = (reservationCode) => {
  window.sessionStorage.setItem(savedReservationCodeKey, reservationCode);
};
const getReservationCode = () => {
  return window.sessionStorage.getItem(savedReservationCodeKey);
};
const removeReservationCode = () => {
  return window.sessionStorage.removeItem(savedReservationCodeKey);
};

const setCertificate = ({ reservationCode, token }) => {
  window.sessionStorage.setItem(certificateReservationKey, reservationCode);
  window.sessionStorage.setItem(certificateTokenKey, token);
};
const getCertificate = () => {
  const reservationCode = window.sessionStorage.getItem(certificateReservationKey);
  const token = window.sessionStorage.getItem(certificateTokenKey);
  return { reservationCode, token };
};
const removeCertificate = () => {
  window.sessionStorage.removeItem(certificateTokenKey);
  window.sessionStorage.removeItem(certificateReservationKey);
};

const agree = () => {
  window.sessionStorage.setItem(agreementKey, true);
};
const isAgreed = () => {
  return window.sessionStorage.getItem(agreementKey);
};
const requireAgreement = (functionKey) => {
  window.sessionStorage.setItem(requiredAgreementKey, functionKey);
};
const _removeRequiredAgreement = () => {
  window.sessionStorage.removeItem(requiredAgreementKey);
};
const popRequiredAgreement = () => {
  const agreementRequiredFunc = window.sessionStorage.getItem(requiredAgreementKey);
  _removeRequiredAgreement();
  return agreementRequiredFunc || null;
};
const removeAgreement = () => {
  window.sessionStorage.removeItem(agreementKey);
};

const removeAll = () => {
  removeReservationCode();
  removeAgreement();
  removeCertificate();
  _removeRequiredAgreement();
};

export default {
  setReservationCode,
  getReservationCode,
  setCertificate,
  getCertificate,
  agree,
  popRequiredAgreement,
  isAgreed,
  requireAgreement,
  removeCertificate,
  removeAgreement,
  removeAll
};
